module.exports = __webpack_public_path__ + "media/images/area/maps/chugoku-8cddb9d6ecc4f2b0f2920a7d430464cb.svg";